import { render, staticRenderFns } from "./ZonalSettings.vue?vue&type=template&id=0030963a"
import script from "./ZonalSettings.vue?vue&type=script&lang=js"
export * from "./ZonalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports